<template>
  <div
    id="slider-ball"
    :style="[
      selection === 50 && wait? 'width:'+ballSize+'px' : 'width: 47%',
      color =='black' ? 'background: var(--primary-font-color, #53565A)'
      : 'background: var(--secondary-font-color, #53565A)'
    ]"
  />
</template>
<script setup lang="ts">
import { Color, type TypeColor, FontColor } from '../../interfaces';
import { watch, ref } from 'vue'
export interface PropsSliderThumb {
  color?: TypeColor
  selection?: number
  ballSize?: number
}
const props = withDefaults(defineProps<PropsSliderThumb>(), {
  color: Color.white,
  selection: 50,
  ballSize: 0
})
let init = ref<number>(-1)
let initialAnimation = ref<boolean>(true)
const wait = ref<boolean>(true)
watch(() => props.selection, (newVal) => {
  wait.value = false

  if(init.value == -1){
    setTimeout(()=>{
        initialAnimation.value = false
    }, 200)
  }
  init.value = 1
})
</script>
<style lang="scss" scoped>
  #slider-ball{
    border-radius: 15rem;
    transition-duration: 300ms;
    animation-timing-function: ease-in;
  }
</style>
